import { getItemsFromCollection } from "directus/src/operations";

export async function fetchProjectsForTimesheetReview(search = "") {
  try {
    const query = {
      fields: ["id", "name"],
      filter: {
        status: {
          _eq: "active",
        },
        _or: [
          {
            jobs: {
              access: {
                employee: {
                  user: { _eq: "$CURRENT_USER" },
                },
                role: {
                  _in: ["job_coordinator", "milestone_coordinator"]
                },
              },
              status: {
                _in: ["in_progress", "in_review"],
              },
            }
          }
        ],
      },
      search: search,
      sort: ["name"],
      limit: -1,
    };

    const data = await getItemsFromCollection("projects", query);
    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function fetchJobsForTimesheetReview(search = "") {
  try {
    const baseFilter = {
      status: {
        _in: ["in_progress", "moving_slow", "on_hold", "in_review"],
      },
      employees: {
        reviewer: {
          user: { _eq: "$CURRENT_USER" },
        },
      },
    };

    // Only add search-related filtering if search is provided
    const searchFilter =
      search?.trim() !== ""
        ? {
            _and: [
              baseFilter,
              {
                _or: [
                  {
                    name: {
                      _contains: search,
                    },
                  },
                  {
                    project: {
                      name: {
                        _contains: search,
                      },
                    },
                  },
                ],
              },
            ],
          }
        : baseFilter;

    const query = {
      fields: ["id", "name", "project.name"],
      filter: searchFilter,
      sort: ["project.name"],
      limit: -1,
    };

    const response = await getItemsFromCollection("jobs", query);

    const data = response.map((job) => ({
      name: job.name,
      id: job.id,
      projectName: job.project.name,
    }));

    return data;
  } catch (error) {
    console.log(error);
    return error;
  }
}
